<script setup lang="ts">
import OrganizationView from '@/components/Organization/OrganizationView.vue'
import {
    ORGANIZATIONS_APIS_HREF,
    ORGANIZATIONS_NETWORKS_HREF,
    ORGANIZATIONS_ROLES_HREF,
    ORGANIZATIONS_USERS_HREF,
    ORGANIZATIONS_USERS_ROUTES
} from '@/router/routing/organizationRouting/organizationRoutes'
import store from '@/store'
import { EOrganizationActions } from '@/store/organizationStore/OrganizationStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { defaultOrganizationModel, type OrganizationModel } from '@/types/models/OrganizationModel'
import {
    EOrganizationsApisTabPerm,
    EOrganizationsNetworksTabPerm,
    EOrganizationsRolesTabPerm,
    EOrganizationsTabPerm,
    EOrganizationsUsersTabPerm
} from '@/types/permissions/OrganizationsPermissionsEnum'
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const organizationStore = computed(() => store.state.organization)

const data = ref<OrganizationModel>({ ...defaultOrganizationModel })
const isLoading = ref(false)

const getOrganization = () => {
    isLoading.value = true
    store
        .dispatch(`${EStoreModules.ORGANIZATION}/${EOrganizationActions.FETCH_MY_ORGANIZATION}`)
        .then(res => (data.value = res))
        .finally(() => (isLoading.value = false))
}

onMounted(() => getOrganization())

const goToCreate = () => router.push(ORGANIZATIONS_USERS_ROUTES.createUrl)
const goToDetail = (userId: number) => router.push(ORGANIZATIONS_USERS_ROUTES.buildUrl(userId))
</script>

<template>
    <OrganizationView
        :data="data"
        :isLoading="organizationStore.isLoading"
        @goToDetail="goToDetail"
        @goToCreate="goToCreate"
        @refresh="getOrganization()"
        :informationsPermission="EOrganizationsTabPerm"
        :usersViewPermission="EOrganizationsUsersTabPerm"
        :usersViewButtonsHref="ORGANIZATIONS_USERS_HREF"
        :networksViewPermission="EOrganizationsNetworksTabPerm"
        :networksViewButtonsHref="ORGANIZATIONS_NETWORKS_HREF"
        :rolesViewPermission="EOrganizationsRolesTabPerm"
        :rolesViewButtonsHref="ORGANIZATIONS_ROLES_HREF"
        :apisViewPermission="EOrganizationsApisTabPerm"
        :apisViewButtonsHref="ORGANIZATIONS_APIS_HREF"
        showRoles />
</template>
